import React, {useEffect,useState,useRef } from 'react'
import store from '../../../store';
import { connect } from "react-redux";
import Button from './input/Button'
import Input from './input/Input'
import GInput from '../../common/input/ginput';
import Alert from './Alert'
import { GetRequest } from './helper';
import { countdown, stopTimer } from './helper';
import { renderImg } from '../../common/icons/img';
import { apiUrl } from './constants';
import Calendar from './calendar';
import moment from 'moment';
import { ExIcon } from './svg';
import { Search } from '../../common/icons/svg';
import AccountLoader from '../../manageAccount/accountLoader';
import Card from './card';
import { resp } from '../resp';
import { updatePnrEnqiryData, updatePnrEnqiryTripData } from '../../../actions/search-actions';
import Bookingcard from './bookingcard';
import { PHONE_NUM, PHONE_NUM_ERR, t } from '../../../translations/pnrEnquiry/GuestMobile';
import { SEARCH,LOCKOTP_MSG, tCommon } from '../../../translations/Common';
import { tPnrCommon, RECENT_BOOKING, RESEND, SEND_OTP, OTP, OTP_RESEND_MSZ, OTP_RESEND_OPT,CNTRY_CODE,ENT_CC } from '../../../translations/pnrEnquiry/Common';

const GuestMobile = (props) => {
    const { setCardData } = props
    const propdata = store.getState();
    const pnrEnquiryData = propdata.search.pnrEnquiryData;
    const [user, setUser] = useState({code:'+91',name:'India',cc: 'India +91', mobile: '', otp: '', obr: '' });
    const [loader, setLoader] = useState(false);
    const [otpSent, setOtpSent] = useState(false);
    const [resend, setResend] = useState("");
    const [alert, setAlert] = useState({ show: false, msg: '' });
    const [selDate, setSelDate] = useState(new Date());
    const [bookingData, setBookingData] = useState(false);
    const [showDropFrCountryCode,setShowDropFrCountryCode] = useState(false);
    const [searchCountryCode,setSearchCountryCode] = useState("");
    const [filterCountryData,setFilterCountryData] = useState([]);
    const [countryData,setCountryData] = useState([]);
    const dropdownRef = useRef();

    useEffect(()=>{
       getCountryDetails();
    },[])

    const getCountryDetails = () => {
        setLoader(true);
        const url = `${apiUrl.getcountryCode}`;
        GetRequest(url)
           .then((response) => {
              setLoader(false);
              let countryData = response.CountriesResult;
              setCountryData(countryData);
              setFilterCountryData(countryData)
           })
           .catch(() => { setLoader(false) });
    };

    const handleccData = (el) =>{
        setUser({ ...user,code:el.CountryCode,name:el.CountryName });
        setShowDropFrCountryCode(false)
    }

    const handleSearchCountryCode = (searchVal) =>{
        setSearchCountryCode(searchVal);
        if(searchVal && searchVal.length >0){
           const tempList = countryData.filter((el) => {
              return (el.CountryName.toLowerCase().includes(searchVal.toLowerCase()) || el.CountryCode.toLowerCase().includes(searchVal.toLowerCase()));
           });
           setFilterCountryData(tempList);
        }
     }

    const handleChange = (val, param) => {
        user[param] = val;
        setUser({ ...user });
    }
    const handleAlert = (msg = false) => {
        if (msg) {
            setAlert({ show: true, msg });
        } else {
            setAlert({ show: false, msg: '' })
        }
    }

    const generateOtp = () => {
        const mobile = user.mobile;
        if (mobile && String(mobile).length === 10 && mobile > 6000000000) {
            setLoader(true);
            const url = `${apiUrl.generateOTPV2}?mobileNo=${mobile}`;
            GetRequest(url).then(res => {
                // console.log(JSON.parse(res));
                countdown('mobileClock', 3, 0, setResend);
                if (res.Success === true) {
                    setOtpSent(true);
                    setResend("disable");
                    // countdown('mobileClock', 3, 0, setResend);
                }
                setLoader(false);
            })

        } else {
            setAlert({ show: true, msg: 'Please enter valid Mobile no' })
        }
        user.otp = '';
        setUser({ ...user });
    }


    const verify = () => {
        const mobile = user.mobile;
        const obRef = user.obr;
        const otp = user.otp;
        setLoader(true);
        const url = `${apiUrl.validateOTPV2}?OTP=${otp}&mobileNo=${mobile}`;
        GetRequest(url).then(result => {
            setLoader(false);
            if (result.Success) {
                stopTimer();
                getStatusDetails(mobile);
            } else {
                setAlert({ show: true, msg: result?.IsLocked ? tCommon(LOCKOTP_MSG): "Please enter valid OTP" });
            }
        }).catch((err) => {
            console.log("err", err);
            setLoader(false);
        });
    }

    const getStatusDetails = (mobile) => {
        setLoader(true);
        let url = `${apiUrl.statusDetails}?searchVal=${mobile}&mode=M&obRef=`;
        GetRequest(url).then(result => {
            setLoader(false);
            // result = resp;
            if (result.IsSuccess) {
                let res = result.Data;
                store.dispatch(updatePnrEnqiryData(res));
                store.dispatch(updatePnrEnqiryTripData({ topDtls: {}, pickdropDtls: {} }));
                setBookingData(res);
            } else {
                store.dispatch(updatePnrEnqiryData(false));
                store.dispatch(updatePnrEnqiryTripData({ topDtls: {}, pickdropDtls: {} }));
                setBookingData(false);
            }
        }).catch((err) => {
            console.log("err", err);
            setLoader(false);
        })
    }

    const getParseData = (data) => {
        let rs = [];
        data.forEach(el => {
            let resp = {};
            if (el.pnrNo || el.OldFormatPNR) {
                resp.JourneyDate = el.JourneyDate;
                resp.TripCode = el.TripCode;
                resp.BusType = el.BusDetails[0].BusType;
                resp.ArrivalTime = el.BusDetails[0].DropoffTime;
                resp.BookingDateTime = el.BookingTime;
                resp.BookingRefNo = el.BookingStatus === 'Payment Pending' ? "" : el.pnrNo;
                resp.DepartureTime = el.BusDetails[0].PickupTime;
                resp.DropoffID = el.BusDetails[0].DropoffID;
                resp.DroppoffName = el.BusDetails[0].DropOffName;
                resp.FromCityName = el.BusDetails[0].FromCity;
                resp.ToCityName = el.BusDetails[0].ToCity;
                resp.FromCityID = el.BusDetails[0].FromCityID;
                resp.ToCityID = el.BusDetails[0].ToCityID;
                resp.PickupID = el.BusDetails[0].PickupID;
                resp.PickupName = el.BusDetails[0].PickupName;
                resp.RouteCode = el.RouteCode;
                // resp.PNR = el.OldFormatPNR;
                //resp.BookingStatus = el.BookingStatus === 'Booking' ? "B" : "C";
                resp.PNR = el.BookingStatus === 'Payment Pending' ? "" : el.OldFormatPNR;
                resp.mobile = el.MobileNo;
                resp.BookingStatus = ((el.BookingStatus === 'Payment Pending' || el.BookingStatus === 'PDBF' || el.BookingStatus === 'NA') ? el.BookingStatus : el.BookingStatus === 'Booking' ? "B" : "C");

                resp.showCancel = false;
                resp.showEdit = false;
                resp.viewBokking = false;
            }
            rs.push(resp);
        });
        return rs;
    }

    return (
        <>
            {loader && <AccountLoader />}
            {!pnrEnquiryData && <div className="bookingStatus-inputs">
                <div className="inputs">
                    <div className='firstInput' style={{ width: '25%' }}>
                       {/*  <Input readOnly={true} label="ISD" value="India:+91" onChange={() => { }} /> */}
                       <div className="timetable-input-wrap" style={{position:'relative'}}>
                            <GInput
                                value={user.code +' '+ user.name}
                                errMsg={t(ENT_CC)}
                                label={tPnrCommon(CNTRY_CODE)}
                                validation="countrycode"
                                key={"cc"}
                                iconError={renderImg("flag-icon-error")}
                                readonly={true}
                                icon2={renderImg("filter-left-arrow")}
                                onClick={() => setShowDropFrCountryCode(true)}
                                onIconClick={() => setShowDropFrCountryCode(true)}
                            />
                            <div className={showDropFrCountryCode ? "all-data-opt active" : "all-data-opt"}>
                                <div className="sel-input-wrap">
                                    <div className="srch-icn">
                                        <Search />{" "}
                                    </div>
                                    <input
                                        type="text"
                                        placeholder={'Search Country Code'}
                                        value={searchCountryCode}
                                        onChange={(e) => handleSearchCountryCode(e.target.value)}
                                    />
                                    <span
                                        className="net-drop-up"
                                        onClick={() => setShowDropFrCountryCode(false)}
                                    ></span>
                                </div>
                                <div>
                            </div>
                            <div className="show-all-data scroll" ref={dropdownRef}>
                            {filterCountryData.length > 0 && filterCountryData.map((el, index) => {
                                return (
                                <div
                                    key={el + "-" + index}
                                    className={
                                    el.CountryCode  === user.code
                                        ? " data--list active "
                                        : " data--list "
                                    }
                                    onClick={() => handleccData(el)}
                                >
                                    {el.CountryCode} {el.CountryName}
                                </div>
                                );
                            })}
                            </div>
                            </div>
                        </div>
                    </div>
                    <div className='secInput' style={{ width: '55%' }}>
                        <Input type='tel' label={t(PHONE_NUM)} onChange={(val) => handleChange(val, 'mobile')} validation={'mobile'}
                            errMsg={t(PHONE_NUM_ERR)} value={user.mobile} />
                    </div>
                    <div className="send-button">
                        {
                            otpSent ?
                                <Button text={tPnrCommon(RESEND)} className={`button ${resend !== "disable" && resend !== "" ? `active` : `disable`}`} extraStyle={{ "height": "48px" }} onClick={() => (resend !== "disable" && resend !== "") && generateOtp()} disabled={resend === "disable" && resend !== "" ? true : false} />
                                :
                                <Button text={tPnrCommon(SEND_OTP)} className={`button ${user.code=='+91' ? `active`:`disable`}`} extraStyle={{ "height": "48px" }} onClick={generateOtp} />
                        }
                    </div>
                    <div className='thirInput'>
                        <Input disabled={otpSent ? false : true} type='tel' label={tPnrCommon(OTP)} value={user.otp} validation={'otp'} onChange={(val) => { handleChange(val, 'otp') }} errMsg={""} />
                    </div>

                    <div className="send-button">
                        <Button text={tCommon(SEARCH)} className={`button ${String(user.otp).length === 6 ? `active` : `disable`}`} extraStyle={{ "height": "48px" }} onClick={() => verify()} />
                    </div>


                </div>
                <div className="bookingStatus-message">
                    <div className="message" style={{ display: 'flex', marginTop: '6px' }}>
                        {
                            resend === "" ? "" :
                                resend === "Resend" ? <span>{tPnrCommon(OTP_RESEND_MSZ)}</span> :
                                    <><span style={{ marginRight: '8px', marginTop: '-2px' }}><ExIcon /></span><span>{tPnrCommon(OTP_RESEND_OPT)} </span> <span id="mobileClock" style={{ color: "red", marginLeft: '4px' }}></span></>
                        }
                    </div>
                </div>
            </div>}
            {
                pnrEnquiryData && pnrEnquiryData.length > 0 &&
                <div className='booking-cards'>
                    <Bookingcard cardData={getParseData(pnrEnquiryData)} mobile={user.mobile} />
                </div>
            }
            {
                pnrEnquiryData && pnrEnquiryData.length === 0 &&
                <div className='booking-cards'>
                    <div style={{ fontSize: '16px', fontWeight: '500', textAlign: 'center' }}>{tPnrCommon(RECENT_BOOKING)}</div>
                </div>
            }
            {
                alert.show &&
                <Alert msg={alert.msg} error={true} close={() => handleAlert()} />
            }
        </>

    )
}

const mapStateToProps = function (store) {
    return store;
};
export default connect(mapStateToProps)(GuestMobile);